export const environment = {
    production: false,
    api: {
        baseUrl: 'https://api.obracubica.com/api/v1',
    },
    auth: {
        realm: 'Obra3Dev',
        authority: 'https://auth.obracubica.com/',
        redirectUri: 'https://configurador.obracubica.com',
        postLogoutRedirectUri: 'https://configurador.obracubica.com',
        clientId: 'obra3dev-web',
    },
    availablePageSizes: [20, 50, 100],
    maxUserConfigurations: 5,
    unity: {
        buildName: "PruebaConcepto01_AzureProd",
        loaderPath: `https://obra3devsa.z6.web.core.windows.net/obra3/Build/Builds.loader.js`,
        baseUrl: 'https://obra3devsa.z6.web.core.windows.net/obra3',
        buildDirectoryName: 'Build',
        dataFileName: 'Builds.data.br',
        frameworkFileName: 'Builds.framework.js.br',
        codeFileName: 'Builds.wasm.br',
        streamingAssetsDirectoryName: 'StreamingAssets',
        companyName: "TuCompaniaProd",
        productName: "PruebaConcepto01",
        productVersion: "1.0.0"
    }
};
